module.exports = __webpack_public_path__ + "static/img/qalog02.473c0be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qalog02.png
// module id = R6eP
// module chunks = 1